(function () {
    'use strict';

    angular.module('iMatApp')
        .factory('upload3DModelStateManager', stateManager);

    stateManager.$inject = ['mainWorkspace', 'productFactory', 'upload3DModelUrlStorageService', 'upload3DModelLocalStorageService'];

    function stateManager(mainWorkspace, productFactory, urlStorage, localStorage) {
        var service = {
            runWorkspaceWatching: runWorkspaceWatching,

            restoreProduct: restoreProduct,
            restoreOptions: restoreOptions
        };

        return service;

        // -------------------------------------------------------------------------------------
        function runWorkspaceWatching($scope) {
            $scope.$watch(function () {
                return mainWorkspace.product.getProductInfo();
            }, productChanged, true);

            $scope.$watch(function () {
                return {
                    viewer: {
                        groundPlane: mainWorkspace.options.viewer.groundPlane
                    }
                };
            }, optionsChanged, true);
        }

        function restoreProduct() {
            var productInfo = urlStorage.product();

            if (productInfo) {
                if (productInfo.modelId) {
                    // Product template id will be updated by model later. 
                    productInfo.productTemplateId = null;
                } else {
                    productInfo.productTemplateId = productInfo.productTemplateId || mainWorkspace.options.productTemplateId;
                }

                return productFactory.createByInfo(productInfo);
            } else {
                return productFactory.createDefault(mainWorkspace.options.productTemplateId);
            }
        }

        function restoreOptions() {
            var storedOptions = localStorage.options();

            return angular.merge({}, mainWorkspace.options, storedOptions);
        }

        // -----------------------------------------------------------------------------------------

        function productChanged(newProductInfo) {
            if (newProductInfo.modelId) {
                urlStorage.product(newProductInfo);
            } else {
                urlStorage.product({});
            }
        }

        function optionsChanged(newOptions, oldOptions) {
            if (angular.equals(newOptions, oldOptions)) {
                return;
            }

            localStorage.options(newOptions);
        }
    }
})();